import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AgentTaskStatus, Block } from '~/protos/agents'
import store from '~/store'
interface AgenticUXState {
  isLoading: boolean
  isWorkingOnIt: boolean
  isRightPanelOpen: boolean
  isGeneratingResult: boolean
  isNavigationBarCollapsed: boolean
  blocks: Record<string, Block>
  taskStatusSelected: AgentTaskStatus | undefined
  isRightPanelEditable: boolean
  activeResultIndex: number
  rightPanelWidth: number
}

const defaultState: AgenticUXState = {
  isLoading: false, // whether we're loading a conversation (a.k.a taskObject)
  isWorkingOnIt: false, // whether to show "Working on it..." message
  isRightPanelOpen: false, // whether the right panel is open
  isGeneratingResult: false, // whether the result is being generated
  isNavigationBarCollapsed: false, // whether the navigation bar is collapsed
  taskStatusSelected: undefined, // manual selected taskStatus
  blocks: {},
  isRightPanelEditable: true,
  activeResultIndex: 0, // active result index
  rightPanelWidth: 994
}

const agenticSlice = createSlice({
  name: 'agentic',
  initialState: defaultState,
  reducers: {
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
    },
    setIsWorkingOnIt(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload
      state.isWorkingOnIt = action.payload
    },
    setIsRightPanelOpen(state, action: PayloadAction<boolean>) {
      state.isRightPanelOpen = action.payload
    },
    toggleRightPanel(state, action: PayloadAction<boolean | undefined>) {
      state.isRightPanelOpen =
        action.payload !== undefined ? action.payload : !state.isRightPanelOpen
    },
    setIsGeneratingResult(state, action: PayloadAction<boolean>) {
      state.isGeneratingResult = action.payload
    },
    setIsNavigationBarCollapsed(state, action: PayloadAction<boolean>) {
      state.isNavigationBarCollapsed = action.payload
    },
    upsertBlock(state, action: PayloadAction<{ id: string; block: Block }>) {
      state.blocks[action.payload.id] = action.payload.block
    },
    clearBlocks(state) {
      state.blocks = {}
    },
    setTaskStatusSelected(state, action: PayloadAction<AgentTaskStatus | undefined>) {
      state.taskStatusSelected = action.payload
    },
    setRightPanelEditable(state, action: PayloadAction<boolean>) {
      state.isRightPanelEditable = action.payload
    },
    setActiveResultIndex(state, action: PayloadAction<number>) {
      state.activeResultIndex = action.payload
    },
    setRightPanelWidth(state, action: PayloadAction<number>) {
      state.rightPanelWidth = action.payload
    }
  }
})

export function setRightPanelSpecDisplaying() {
  store.dispatch(setTaskStatusSelected(AgentTaskStatus.FINAL_SPECIFICATION_GENERATED))
  store.dispatch(setIsRightPanelOpen(true))
  store.dispatch(setIsNavigationBarCollapsed(true))
}

export const {
  setIsLoading,
  setIsWorkingOnIt,
  setIsRightPanelOpen,
  toggleRightPanel,
  setIsGeneratingResult,
  setIsNavigationBarCollapsed,
  upsertBlock,
  clearBlocks,
  setTaskStatusSelected,
  setRightPanelEditable,
  setActiveResultIndex,
  setRightPanelWidth
} = agenticSlice.actions

export { defaultState as agenticDefaultState }
export default agenticSlice.reducer
